import React, { Component } from "react";
import "./App.css";

import "../node_modules/jquery/dist/jquery.min.js";
import "../node_modules/bootstrap/js/dist/collapse.js";
import "../node_modules/bootstrap/js/dist/carousel.js";

import Main from "./components/main";

class App extends Component {
  state = {};
  render() {
    return (
      <React.Fragment>
        <Main />
      </React.Fragment>
    );
  }
}

export default App;
